"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Style = _interopRequireDefault(require("./Style"));

/**
 *
 * @deprecated in favour of @remote-com/norma/core/button.
 */
var Button = _styledComponents["default"].button.withConfig({
  displayName: "Button",
  componentId: "sc-1nhlfre-0"
})(["", ";"], _Style["default"]);

var _default = Button;
exports["default"] = _default;